import { Outlet } from "react-router-dom";
import StreamTeamNav from "./StreamTeamNav";

export default function StreamTeamLayout() {
    return (
        <div
            className="min-h-screen w-full bg-zinc-950"
            style={{
                backgroundImage:
                    "linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(/feathers.png)",
                backgroundRepeat: "repeat",
                backgroundSize: "auto",
            }}
        >
            <StreamTeamNav />
            <main className="w-full">
                <Outlet />
            </main>
        </div>
    );
}
